import { Table } from 'antd'
import React from 'react'
import { IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import { IProductGroupMember } from '../../../types/product-group'
import { Tag } from '../../../components/Tag'

interface IProductGroupMembersTableProps {
  members: IProductGroupMember[]
  onRemove?: (objectId: string) => void
}

const ProductGroupMembersTable = ({
  members,
  onRemove,
}: IProductGroupMembersTableProps) => {
  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'numberRow',
      key: 'numberRow',
      align: 'center' as const,
      width: 70,
    },
    {
      title: 'รหัสสินค้า',
      dataIndex: 'code',
      key: 'code',
      width: 160,
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'name',
      key: 'name',
      render: (name: string, member: IProductGroupMember) => (
        <Typography variant="body2" color="text.secondary">
          {name}{' '}
          {member.deleted && (
            <Tag color="error" style={{ marginLeft: 4 }}>
              สินค้าถูกลบ
            </Tag>
          )}
        </Typography>
      ),
    },
    ...(onRemove
      ? [
          {
            title: '',
            key: 'remove',
            align: 'center' as const,
            width: 60,
            render: (_: undefined, member: IProductGroupMember) => (
              <IconButton
                size="small"
                aria-label="เอาสินค้าออกจากกลุ่ม"
                onClick={() => onRemove(member.objectId)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            ),
          },
        ]
      : []),
  ]

  return (
    <Table
      size="small"
      columns={columns}
      dataSource={members.map((member, index) => ({
        ...member,
        key: member.objectId,
        numberRow: index + 1,
      }))}
      locale={{ emptyText: 'ยังไม่มีสินค้าในกลุ่ม' }}
      bordered
      pagination={false}
      scroll={{ y: 360 }}
    />
  )
}

export default ProductGroupMembersTable
